import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
    import { ValidationRule } from '@/model/types'

    type SelectItemKey = string | ((item: any) => string)

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FormSelect',
  props: {
        modelValue: [String, Number, Object],
        items: Array,
        itemValue: {
            type: [String, Function] as unknown as unknown as unknown as () => SelectItemKey,
            default: 'value',
        },
        itemText: { type: [String, Function], default: 'text' },
        rules: {
            type: Array as () => ValidationRule[] | undefined,
            default: undefined,
        },
        label: String,
        required: Boolean,
        disabled: Boolean,
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit

    const selectedValue = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val),
    })

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    style: {"width":"33.3333%","display":"inline-block"},
    class: "p-[5px]",
    items: props.items,
    "item-value": props.itemValue,
    "item-text": props.itemText,
    rules: props.rules,
    label: props.label,
    required: props.required,
    disabled: props.disabled,
    modelValue: selectedValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event))
  }, null, 8, ["items", "item-value", "item-text", "rules", "label", "required", "disabled", "modelValue"]))
}
}

})